<div class="clientnew-component" data-hook="clientnew-component">
  <form class="form-vertical">
    <!-- Organisation -->
    <div class="form-group">
      <label for="org">Firma od. Organisation</label>
      <input type="text" class="form-control"
             autocomplete="noway" autocorrect="off" autocapitalize="on" spellcheck="false"
             placeholder="Name der Organisation"
             ng-model="vm.newclient.companydata.name" id="org"
             typeahead-on-select="vm.setOrgname($item, $model, $label, $event)"
             typeahead-template-url="lastnameTpl"
             typeahead-min-length="1"
             typeahead-editable="true"
             uib-typeahead="org as org.text for org in vm.orgSearch($viewValue)"
             typeahead-no-results="noOrgResults">
    </div>
    <div ng-repeat="pat in vm.orgs">
      <span ng-click="vm.showRecord(pat._id)" class="btn btn-info">Akte</span>
      {{pat.lastname | uppercase }} {{pat.firstname}}, * {{pat.birthdate}}
    </div>
    
    <!-- Nachname -->
    <div class="form-group">
      <label for="nlname">Nachname</label>
      <input type="text" class="form-control"
             autocomplete="noway" autocorrect="off" autocapitalize="on" spellcheck="false"
             placeholder="Nachname"
             ng-model="vm.newclient.primarycontact.lastname" id="nlname"
             typeahead-min-length="1"
             typeahead-template-url="lastnameTpl"
             typeahead-editable="true"
             typeahead-on-select="vm.setLastname($item, $model, $label, $event)"
             uib-typeahead="pat as pat.text for pat in vm.nameSearch($viewValue)"
             typeahead-no-results="noResults">
    </div>

    <!-- Vorname -->
<!--    <div class="form-group">
      <label for="nfname">Vorname</label>
      <input type="text" ng-model="vm.newpatient.firstname" class="form-control"
             autocomplete="noway" autocorrect="off" autocapitalize="on" spellcheck="false"
             id="nfname" placeholder="Vorname">
    </div>-->
  </form>
  
  <!--<i ng-show="loadingNames" class="fa fa-spin fa-spinner"></i>-->
  <div ng-repeat="pat in vm.names">
    <span ng-click="vm.showRecord(pat._id)" class="btn btn-info">Akte</span>
    {{pat.primarycontact.lastname | uppercase }} {{pat.primarycontact.firstname}}, * {{pat.svdata.birthdate}}
  </div>
  
  <div ng-show="noResults" class="form-group">
    <i class="fa fa-warning"></i> Es existiert noch kein {{vm.kunde}} mit diesem Nachnamen
  </div>

  <div ng-show="noOrgResults" class="form-group">
    <i class="fa fa-warning"></i> Es existiert noch keine Organisationen mit diesem Namen
  </div>

  <div class="form-group">
    <div class="btn btn-success btn-spacer-top" ng-click="vm.createPatient(); $parent.$dismiss();">Neuen {{vm.kunden}}
      anlegen
    </div>
    <div class="btn btn-danger btn-spacer-top" ng-click="vm.cancel();">Abbrechen</div>
  </div>
</div>

<script type="text/ng-template" id="lastnameTpl">
  <a>
    <span class="btn btn-info gotorec" ng-click="vm.gotoRecord(match.model)" style="z-index: 1000">Akte</span>
    <span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span>
  </a>
</script>
